// src/services/auth.js
import axios from "axios";



// const API = process.env.REACT_APP_API || "http://localhost:5000/api/v1";
const API = process.env.REACT_APP_API || "/api/v1"; // <-- use relative path in prod

const tokenKey = "app_token";
const userKey = "app_user";

axios.defaults.baseURL = API;

/* =========================
   HELPERS
========================= */

export const getToken = () => localStorage.getItem(tokenKey);

export const getUser = () => {
  const raw = localStorage.getItem(userKey);

  if (!raw || raw === "undefined" || raw === "null") {
    localStorage.removeItem(userKey);
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (err) {
    console.error("Corrupted user in storage:", raw);
    localStorage.removeItem(userKey);
    return null;
  }
};

export const ensureAuthHeader = () => {
  const token = getToken();
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

/* =========================
   🔥 NEW: SESSION EXPIRE HELPER
========================= */

export const handleSessionExpired = () => {
  localStorage.removeItem(tokenKey);
  localStorage.removeItem(userKey);

  delete axios.defaults.headers.common.Authorization;

  window.dispatchEvent(new Event("session-expired"));
};

/* =========================
   AUTH ACTIONS
========================= */

export const login = async (username, password) => {
  const res = await axios.post("/auth/login", { username, password });

  if (!res.data || !res.data.token || !res.data.user) {
    throw new Error("Invalid login response from server");
  }

  const { token, user } = res.data;

  localStorage.setItem(tokenKey, token);
  localStorage.setItem(userKey, JSON.stringify(user));

  axios.defaults.headers.common.Authorization = `Bearer ${token}`;

  return user;
};

export const logout = () => {
  localStorage.removeItem(tokenKey);
  localStorage.removeItem(userKey);
  delete axios.defaults.headers.common.Authorization;
};

/* =========================
   HELPERS
========================= */

export const getCurrentUser = () => {
  return getUser();
};

export const isParokiaAdmin = () =>
  getCurrentUser()?.role === "PAROKIA_ADMIN";